import { queryClient } from "@/configs/react-query";
import LazoChatConversationService from "@/services/ai-chat/LazoChatConversationService";
import { useMutation, useQuery } from "@tanstack/react-query";

export const LAZO_CHAT_CONVERSATION_QUERY_KEY = "lazo-chat-conversation";

// ========== QUERIES ==========

export function useUnreadChatCount() {
  return useQuery({
    queryKey: [LAZO_CHAT_CONVERSATION_QUERY_KEY],
    queryFn: () => LazoChatConversationService.getCountChats().then((r) => r.getContentOrThrowError()),
    initialData: 0,
    placeholderData: 0,
    refetchOnWindowFocus: false,
  });
}

export function setUnreadChatCount(count: number) {
  queryClient.setQueryData([LAZO_CHAT_CONVERSATION_QUERY_KEY], count);
}

export function useConversationsWithKam(userExternalId: string, tenantExternalId: string, enabled: boolean = true) {
  return useQuery({
    queryKey: [LAZO_CHAT_CONVERSATION_QUERY_KEY, "with-kam", userExternalId, tenantExternalId],
    queryFn: () =>
      LazoChatConversationService.getConversationsWithKam(userExternalId, tenantExternalId).then((r) => r.getContentOrThrowError()),
    enabled: !!userExternalId && !!tenantExternalId && enabled,
    meta: {
      errorMessage: "Error fetching conversations with KAM",
    },
  });
}

// ========== MUTATIONS ==========

export function useCreateChatWithKam() {
  return useMutation({
    mutationFn: (tenantExternalId: string) =>
      LazoChatConversationService.createChatWithKam(tenantExternalId).then((r) => r.getContentOrThrowError()),
    mutationKey: [LAZO_CHAT_CONVERSATION_QUERY_KEY, "create-with-kam"],
    meta: {
      successMessage: "Chat with KAM created successfully",
      errorMessage: "Error creating chat with KAM",
    },
  });
}
